<template>
  <table class="table-hover reports-table app-and-urls-reports-table table">
    <tbody class="thead">
      <tr>
        <th>{{ walker.sub_label }}</th>
        <th>{{ walker.third_label }}</th>
        <th>App or site</th>
        <th>Classification</th>
        <th>Time spent (hrs)</th>
        <th>Percent used</th>
      </tr>
    </tbody>

    <!--eslint-disable vue/require-v-for-key -->
    <template v-for="section in tableData.sections">
      <tbody class="grouping-header">
        <tr>
          <th colspan="6">
            <template v-if="walker.main_type === 'project'">
              <ReportTableAvatarInitial
                :text="section.main"
                class-modifier="avatar avatar-speck"
              />
              {{ section.main }}
            </template>
            <template v-else-if="walker.main_type === 'user'">
              <ReportTableAvatar
                :user-id="section.main_id"
                :url="section.rows[0].record.avatar_url"
              />
              {{ section.main }}
            </template>
            <template v-else-if="walker.main_type === 'date'">{{ format_date_label(section.main) }}</template>
            <template v-else>{{ section.main }}</template>
          </th>
        </tr>
      </tbody>
      <tbody class="tbody">
        <tr
          v-for="row in section.rows"
          :class="row_class(row.sub_show_data)"
        >
          <template v-if="walker.sub_show">
            <td v-if="row.sub_show_data">
              <template v-if="walker.sub_type === 'project'">
                <ReportTableAvatarInitial
                  :text="row.record.sub"
                  class-modifier="avatar avatar-speck"
                />
                {{ row.record.sub }}
              </template>
              <template v-else-if="walker.sub_type === 'user'">
                <ReportTableAvatar
                  :user-id="row.record.sub_id"
                  :url="row.record.avatar_url"
                />
                {{ row.record.sub }}
              </template>
              <template v-else-if="walker.sub_type === 'date'">{{ format_date_label(row.record.sub) }}</template>
              <template v-else>{{ row.record.sub }}</template>
            </td>
            <td v-else></td>
          </template>
          <template v-if="walker.third_show">
            <td v-if="row.third_show_data">
              <template v-if="walker.third_type === 'project'">
                <ReportTableAvatarInitial
                  :text="row.record.third"
                  class-modifier="avatar avatar-speck"
                />
                {{ row.record.third }}
              </template>
              <template v-else-if="walker.third_type === 'user'">
                <ReportTableAvatar
                  :user-id="row.record.third_id"
                  :url="row.record.avatar_url"
                />
                {{ row.record.third }}
              </template>
              <template v-else-if="walker.third_type === 'date'">{{ format_date_label(row.record.third) }}</template>
              <template v-else>{{ row.record.third }}</template>
            </td>
            <td v-else></td>
          </template>
          <td>{{ row.record.name || row.record.alt_name.substring(0, 45) }}</td>
          <td>{{ row.record.classification_label }}</td>
          <td>{{ row.record.tracked | formatDuration('auto', null, false, true) }}</td>
          <td>
            {{ row.record.tracked | percentage(row.record.total) }}
            <ReportTableProgressBar
              :tracked="row.record.tracked"
              :total="row.record.total"
              :success="row.record.item_type === 'apps'"
              class="progress-full dont-animate"
            />
          </td>
        </tr>
      </tbody>
    </template>
    <!--eslint-enable vue/require-v-for-key -->
  </table>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppsAndUrlsReportTable',
  props: {
    tableData: Object,
  },
  computed: {
    ...mapGetters(['walker']),
  },
  methods: {
    row_class(new_record) {
      return new_record ? 'has-border' : '';
    },
    format_date_label(value) {
      if (value === 'summed_date') {
        return (
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date)) +
          ' - ' +
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date_end))
        );
      }

      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
  },
};
</script>
